"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = exports.OpenIcon = exports.CloseIcon = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const getIconStyles = ({
  theme
}) => ({
  display: 'flex',
  height: '32px',
  padding: theme.spacing(0, 2.8, 0, 2),
  width: '32px'
});
const OpenIcon = exports.OpenIcon = (0, _mui.styled)(_icons.BubbleHelpFilled)(getIconStyles);
const CloseIcon = exports.CloseIcon = (0, _mui.styled)(_icons.Clear)(getIconStyles);
const Progress = exports.Progress = (0, _mui.styled)(_mui.CircularProgress)(({
  theme
}) => ({
  margin: theme.spacing(3)
}));
